"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalAlert = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = require("../Icon");
var Modal_1 = require("./Modal");
var Typography = require("../Typography");
var ModalActions_1 = require("./ModalActions");
var iconForType = {
    info: 'InfoCircle',
    success: 'CheckCircle',
    attention: 'AlertCircle',
    critical: 'Trash01',
};
var ModalAlert = function (_a) {
    var show = _a.show, onConfirm = _a.onConfirm, onCancel = _a.onCancel, onDismiss = _a.onDismiss, content = _a.content, heading = _a.heading, titles = _a.titles, _b = _a.type, type = _b === void 0 ? 'info' : _b;
    return ((0, jsx_runtime_1.jsxs)(Modal_1.Modal, __assign({ title: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: iconForType[type], className: ' squid-ml-auto squid-mr-auto', variant: "outline", size: "xl", fill: type }), onDismiss: onDismiss, show: show, closeIcon: true }, { children: [(0, jsx_runtime_1.jsx)(Typography.Heading, __assign({ variant: "md", className: "squid-text-center squid-mt-3 squid-mb-3 squid-text-alias-color-text-base" }, { children: heading })), (0, jsx_runtime_1.jsx)(Typography.Body, __assign({ size: "lg", className: "squid-text-alias-color-text-weak" }, { children: content })), (0, jsx_runtime_1.jsx)(ModalActions_1.ModalActions, { titles: titles, onConfirm: onConfirm, confirmButtonProps: type === 'critical' ? { variant: 'critical' } : undefined, onCancel: onCancel })] })));
};
exports.ModalAlert = ModalAlert;
